import axiosClient from '@/api/axiosClient';
import { API_MISSION_DAILY_REWARD, API_SEVEN_DAYS_LOGIN } from '@/config/paths/API_PATH';

const getSevenDaysLogin = async (params) => {
  const response = await axiosClient.get(API_SEVEN_DAYS_LOGIN, { params });
  return response.data;
};

const getDailyRewardMission = async (params) => {
  const response = await axiosClient.get(API_MISSION_DAILY_REWARD, { params });
  return response.data;
};

const updateDailyRewardMission = async (data) => {
  const response = await axiosClient.put(API_MISSION_DAILY_REWARD, data);
  return response.data;
};

export { getSevenDaysLogin, getDailyRewardMission, updateDailyRewardMission };
